export function formatTimelineTimeLabel(
  timestampMs: number | null,
  raw: string | null | undefined
): string {
  if (timestampMs === null) return raw ? raw : 'Unknown time';
  try {
    return new Date(timestampMs).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  } catch {
    return raw ? raw : 'Unknown time';
  }
}

export function humanizeTimelineStatusLabel(value: string): string {
  const cleaned = value.replace(/[._-]/g, ' ').replace(/\s+/g, ' ').trim();
  if (cleaned === '') return 'Event';
  return cleaned
    .split(' ')
    .map((word) => {
      const lower = word.toLowerCase();
      return lower.length > 0 ? lower.charAt(0).toUpperCase() + lower.slice(1) : lower;
    })
    .join(' ');
}
